import { ConfigContext } from "./config-context";
import { useInheritContext } from "../ContextForwarder";

// higher order decorator for components that need translations
export const withConfig = (WrappedComponent) => (props) => {
    const value = useInheritContext("config", ConfigContext);
    return <WrappedComponent {...props} {...value} />;
};
